












































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class NoData extends Vue {
  @Prop({ type: [Number, String], default: 150 }) private width!:
    | number
    | string;
}
